let localConfig = {
  header: `<b>Sign-in</b> Sheet`,

  nameListText: `Seat Number	ID	Name
32	492000032	趙布乙
47	492000047	劉布庚
55	492000055	黃布戊
18	492000018	李布辛
34	492000034	趙布丁
27	492000027	王布庚
35	492000035	趙布戊
10	492000010	陳布癸
36	492000036	趙布己
37	492000037	趙布庚
9	492000009	陳布壬
7	492000007	陳布庚
43	492000043	劉布丙
50	492000050	劉布癸
46	492000046	劉布己
44	492000044	劉布丁
15	492000015	李布戊
30	492000030	王布癸
6	492000006	陳布己
22	492000022	王布乙
56	492000056	黃布己
39	492000039	趙布壬
17	492000017	李布庚
5	492000005	陳布戊
25	492000025	王布戊
58	492000058	黃布辛
24	492000024	王布丁
28	492000028	王布辛
48	492000048	劉布辛
57	492000057	黃布庚
42	492000042	劉布乙
49	492000049	劉布壬
52	492000052	黃布乙
3	492000003	陳布丙
26	492000026	王布己
45	492000045	劉布戊
21	492000021	王布甲
19	492000019	李布壬
38	492000038	趙布辛
51	492000051	黃布甲
11	492000011	李布甲
13	492000013	李布丙
1	492000001	陳布甲
41	492000041	劉布甲
8	492000008	陳布辛
54	492000054	黃布丁
31	492000031	趙布甲
29	492000029	王布壬
53	492000053	黃布丙
2	492000002	陳布乙
12	492000012	李布乙
40	492000040	趙布癸
20	492000020	李布癸
16	492000016	李布己
23	492000023	王布丙
14	492000014	李布丁
4	492000004	陳布丁
33	492000033	趙布丙`,

  cellTemplate: `[Seat Number]
[ID]
[Name]`,

  layoutColumnNumber: 3,
  layoutRowNumber: 15,
}

// ----------------------------------------------------------------

let localConfigEnv = {
  locale: 'zh-TW'
}

for (let name in localConfigEnv) {
  localConfig[name] = localConfigEnv[name]
}

export default localConfig